module.exports = __webpack_public_path__ + "img/san.a787ada3.png";